<script lang="scss" setup></script>

<template>
   <RouterView />
</template>
